export default __webpack_public_path__ + "static/media/logo.d33e28d3.svg";